module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-group"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Paket Mata Pelajaran")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("List Paket Mata Pelajaran")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Daftar Paket Mata Pelajaran")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createVideo()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Paket")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Paket Mata Pelajaran")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.packageList,
      "has-action": true,
      "has-publish": true,
      "has-edit": true,
      "headers": _vm.headers
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.showBab($event)
      },
      "editNewTab": function($event) {
        return _vm.editPackage($event)
      },
      "deleted": function($event) {
        return _vm.deletePackage($event)
      },
      "publishing": function($event) {
        return _vm.publish($event)
      },
      "unpublishing": function($event) {
        return _vm.unpublish($event)
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a6c5a9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bimbel_online/paket_mapel/ListPaketMapel.vue
// module id = 1294
// module chunks = 0